import MockTextMessage from './MockTextMessage'
export default MockTextMessage
export * from './MockTextMessage'
